import * as actionTypes from './actionTypes';
import { createAction } from '../store/Utilities'
// ei enää haetakkaa tääl actionissa (thunk), vaan sagassa, tsiigaa /sagas/newsSagas.js
// https://hackernoon.com/replacing-redux-thunks-with-redux-sagas-4aa306854925
export const actions = {
  pending: () => createAction(actionTypes.LOAD_NEWS_ASYNC.PENDING),
  success: (articles) => createAction(actionTypes.LOAD_NEWS_ASYNC.SUCCESS, { articles }),
  error: (error) => createAction(actionTypes.LOAD_NEWS_ASYNC.ERROR, { error })
}